// ChevronDown icon matching EBX UI component library design
function ChevronDownIcon({
  size = 16,
  color = 'currentColor',
}: {
  size?: number;
  color?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill={color}
        d="M12.829 6.271 8.405 10.51c-.148.125-.287.175-.405.175a.6.6 0 0 1-.384-.154L3.172 6.27c-.223-.21-.23-.583-.017-.784a.553.553 0 0 1 .785-.017L8 9.36l4.06-3.888a.553.553 0 0 1 .785.016c.213.199.206.572-.016.782"
      />
    </svg>
  );
}

export default ChevronDownIcon;
